'use strict';

import { CoreRepository } from '../CoreRepository';
import { Automation } from '../../Entities/Automation/Automation';
import { AutomationCollection } from '../../Collections/Automation/AutomationCollection';

export class AutomationRepository extends CoreRepository {
  public getAutomations(userId: number, options = {}) {
    return this.webAPI.getAutomations(userId, options).then((response) => {
      const collection = new AutomationCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Automation();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getAutomation(userId: number, automationId: number, options = {}) {
    return this.webAPI.getAutomation(userId, automationId, options).then((response) => {
      const item = new Automation();
      item.hydrate(response);

      return item;
    });
  }

  public getAgencyAutomations(agencyId: number, options = {}) {
    return this.webAPI.getAgencyAutomations(agencyId, options).then((response) => {
      const collection = new AutomationCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Automation();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public updateAutomation(userId: number, automationId: number, payload: any) {
    return this.webAPI.updateAutomation(userId, automationId, payload).then((response) => {
      const item = new Automation();
      item.hydrate(response);

      return item;
    });
  }

  public createAutomation(userId: number, payload: any) {
    return this.webAPI.createAutomation(userId, payload).then((response) => {
      const item = new Automation();
      item.hydrate(response);

      return item;
    });
  }

  public deleteAutomation(userId: number, automationId: number) {
    return this.webAPI.deleteAutomation(userId, automationId).then((response) => {
      return response;
    });
  }
}
